// extracted by mini-css-extract-plugin
export default {"FooterLink":"FooterLink_FooterLink__ljXzf","FooterLink__head":"FooterLink_FooterLink__head__42BDK"};